<template>
  <div>
    <input type="file" ref="upload" :accept="allowed_files" hidden @change="setFile">
    <v-tooltip bottom>
      <template v-slot:activator="{ on }">
        <gg-btn secondary v-on="on" @click="openUploadInput">
          <span>Add file</span>
        </gg-btn>
      </template>
      <span>Allowed types are {{ allowed_files_human }}</span>
    </v-tooltip>

    <div v-if="files.length" class="pt-4">
      <v-chip
        close
        label
        class="mr-2"
        v-for="(file, index) in files" :key="index"
        @click:close="deleteFile(file)"
      >
        <v-icon left>
          mdi-file
        </v-icon>
        {{ file.name }}
      </v-chip>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import {
  uploadFile,
  deleteFile
} from '@/helpers/file-upload'

export default {
  name: 'Attachments',
  data: () => ({
    files: [],
    counter: 0,
    allowed_files: [
      'image/png',
      'image/jpeg',
      'image/gif',
      'text/plain',
      'application/msword',
      'application/pdf',
      'application/excel',
      'application/powerpoint',
    ],
    allowed_files_human: 'PNG. JPG, GIF, TXT, DOC, XLS, PPT, PDF',
    allowed_size: 32 // in mb
  }),
  methods: {
    ...mapActions(['reportError']),
    openUploadInput () {
      this.$refs.upload.click()
    },
    // A wrapper function around Filereader API that grant us to use async functions with Filereader
    readUploadedFile (inputFile) {
      const temporaryFileReader = new FileReader()

      return new Promise((resolve, reject) => {
        temporaryFileReader.onerror = () => {
          temporaryFileReader.abort()
          reject(new DOMException('Problem parsing input file.'))
        }

        temporaryFileReader.readAsDataURL(inputFile)

        temporaryFileReader.onload = () => {
          resolve({
            file_name: inputFile.name,
            file_size: inputFile.size,
            file_type: inputFile.type,
            file: temporaryFileReader.result
          })
        }
      })
    },
    checkMimeType (file) {
      return this.allowed_files.includes(file.type)
    },
    checkFileSize (file) {
      return file.size < this.allowedSize
    },
    async setFile (e) {
      if (!this.checkMimeType(e.target.files[0])) {
        this.reportError(`File type is not allowed. Allowed types are ${this.allowed_files_human}`)

        return
      }

      if (!this.checkFileSize(e.target.files[0])) {
        this.reportError(`File size is too big. Please select file less than ${this.allowedSileTitle}`)

        return
      }

      let tmpid = Math.round(Math.random() * 1000000)

      this.files.push({
        id: tmpid,
        name: e.target.files[0].name,
        progress: 0,
      })

      const file = e.target.files[0]

      try {
        const params = {}

        params.sid = this.sid

        const fileContents = await this.readUploadedFile(file)

        const combined = { ...params, ...fileContents }

        const id = await uploadFile(combined)

        this.$refs.upload.value = ''

        this.uploadComplete(tmpid, id)
      } catch (e) {
        for (let i = 0; i < this.files.length; i++) {
          if (this.files[i].id === tmpid) {
            this.files.splice(i, 1)
          }
        }

        this.reportError(e)
      }
    },
    uploadComplete (tmpid, attachment_id) {
      for (let i = 0; i < this.files.length; i++) {
        if (this.files[i].id === tmpid) {
          this.files[i].attachment_id = attachment_id
          this.$forceUpdate()
        }
      }

      const attachmentIds = this.files.map(i => i.attachment_id).join(',')

      this.$emit('update', attachmentIds)
    },
    async deleteFile (file, index) {
      await deleteFile(file.attachment_id)
      this.files.splice(index, 1)

      const attachmentIds = this.files.map(i => i.attachment_id).join(',')
      this.$emit('update', attachmentIds)
    },
    clearAttachments () {
      this.files = []
    }
  },
  computed: {
    allowedSize () {
      return this.allowed_size * 1048576
    },
    allowedSileTitle () {
      return `${this.allowed_size} MB`
    }
  }
}
</script>
